import { ApiTask } from '@/entities/task/api/tasksApi'

export const extractAccountId = (taskData: ApiTask): string => {
  if (taskData.accountId) return taskData.accountId

  const { source } = taskData
  if (source?.id) return source.id
  if (source?.name) return source.name

  return ''
}
